var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMna0Yq871Zo71Dg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.68245 15.5031C6.53995 15.5031 6.39745 15.4506 6.28495 15.3381C6.06745 15.1206 6.06745 14.7606 6.28495 14.5431L11.175 9.65313C11.535 9.29313 11.535 8.70813 11.175 8.34813L6.28495 3.45813C6.06745 3.24063 6.06745 2.88062 6.28495 2.66313C6.50245 2.44563 6.86245 2.44563 7.07995 2.66313L11.97 7.55312C12.3525 7.93562 12.57 8.45313 12.57 9.00063C12.57 9.54813 12.36 10.0656 11.97 10.4481L7.07995 15.3381C6.96745 15.4431 6.82495 15.5031 6.68245 15.5031Z",
    fill: "#868484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMna0Yq871Zo71Dg);
export default __webpack_public_path__ + "static/media/mna0yq87-1zo71dg.db5386a9ef4a4baf83fe5f2b71ace2a0.svg";
export { ForwardRef as ReactComponent };